var ButtonDropdown = require("components/utility/ButtonDropdown");

require("utility/validating_input.scss");

class ValidatingInput extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			error: null
		};
	}

	val() {
		if (this.props.type == "proxy") {
			return this.props.proxySource() || "";

		} else if (this.props.type == "button-dropdown") {
			return this.refs.input.val();

		} else {
			return this.refs.input.value;
		}
	}

	focus() {
		this.refs.input.focus()
	}

	reset() {
		// Assumes this is define
		if (this.refs.input.reset) {
			this.refs.input.reset()
		} else {
			this.refs.input.value = "";
		}
		
	}

	// Return true if the input is valid, false otherwise
	//    by default, it'll display the error message, unless changeErrorState is false
	validate(changeErrorState) {
		changeErrorState = changeErrorState !== false;

		var text = this.val();

		// If validators aren't an array, make it so
		var validators = this.props.validators || [];
		if (!_.isArray(validators)) {
			validators = [validators];
		}

		for (var i = 0; i < validators.length; i += 1) {
			var errorMessage = validators[i](text, this.props.inputName);
			if (errorMessage) {
				var useMessage = this.props.errorMessage ? this.props.errorMessage : errorMessage;
				if (changeErrorState) {
					this.setState({ error: useMessage });
				}
				return false;
			} else if (changeErrorState) {
				this.setState({ error: null });
			}
		}

		return true;
	}

	resetErrors() {
		this.setState({ error: null });
	}

	// removes/changes error message after a change
	checkResetError() {
		// Don't ever ADD errors
		if (this.state.error && this.validate(false)) {
			this.resetErrors();
		}
	}

	render() {
		var inputProps = _.omit(this.props, "type", "inputName", "validators", "errorMessage",
			"selectOptions", "inputClassName", "className", "defaultSubText", "proxySource");

		inputProps.className = this.state.error ? "errorInput" : "";
		if (this.props.inputClassName) {
			inputProps.className += " " + this.props.inputClassName
		}

		if (this.props.type == "select") {
			inputProps.onChange = function() {
				this.checkResetError()
				if (this.props.onChange) {
					this.props.onChange()
				}
			}.bind(this)
			var input = (
				<select ref="input" { ...inputProps } >
					{ this.props.selectOptions }
				</select>
			);

		} else if (this.props.type == "button-dropdown") {
			if (inputProps.onChange) 
			inputProps.onChange = function() {
				this.checkResetError()
				if (this.props.onChange) {
					this.props.onChange()
				}
			}.bind(this)
			var input = (
				<ButtonDropdown ref="input" dropdownDisplay="link"
					inputMode={ true } { ...inputProps }>
					{ this.props.selectOptions }
				</ButtonDropdown>
			);

		} else if (this.props.type == "textarea") {
			inputProps.onKeyUp = this.checkResetError;
			var input = (<textarea ref="input" { ...inputProps } />);

		} else if (this.props.type == "proxy") {
			var input = undefined;

		} else {
			inputProps.onKeyUp = this.checkResetError;
			var input = (
				<input ref="input" { ...inputProps } type={ this.props.type || "text" } />
			);
		}

		if (this.state.error) {
			var subDisplay = (
				<p className="subText errorDisplay">{ this.state.error }</p>
			);
		} else if (this.props.defaultSubText) {
			var subDisplay = (
				<p className="subText">{ this.props.defaultSubText }</p>
			);
		}

		var className = "validatingInput";
		if (this.props.className) {
			className += " " + this.props.className
		}

		return (
			<div className={ className }>
				{ input }
				{ subDisplay }
			</div>
		);
	}
};

ValidatingInput.Validators = {
	PRESENT: function(text, inputName) {
		inputName = inputName || "This input";

		if (text == undefined || text.trim().length == 0) {
			return inputName + " is required";
		}
		return null;
	},

	EMAIL: function(text, inputName) {
		inputName = inputName || "This email";

		if (!ValidatingInput.EMAIL_REGEX.test(text)) {
			return inputName + " isn't valid";
		}
		return null;
	},

	URL: function(text, inputName) {
		inputName = inputName || "This website URL";

		if (!ValidatingInput.URL_REGEX.test(text)) {
			return inputName + " isn't valid";
		}
		return null;
	},

	INTEGER: function(text, inputName) {
		inputName = inputName || "This input";

		if (parseInt(text) == NaN) {
			return inputName + " must be a number";
		}

		return null;
	},

	POSITIVE_INTEGER: function(text, inputName) {
		inputName = inputName || "This input";

		if (parseInt(text) == NaN) {
			return inputName + " must be a number";
		} else if (parseInt(text) < 1) {
			return inputName + " must be positive";
		}
		return null;
	},

	NON_NEGATIVE: function(text, inputName) {
		if (parseInt(text) != NaN && parseInt(text) < 0) {
			return inputName + " can't be negative";
		}
		return null;
	},

	minLength: function(minLength) {
		return function(text, inputName) {
			inputName = inputName || "This input";
			if (text.trim().length < minLength) {
				var noun = (minLength == 1) ? "character" : "characters";
				return inputName + " must be " + minLength + "+ " + noun;
			}
			return null;
		}
	},

	not: function(avoidValue) {
		return function(text, inputName) {
			inputName = inputName || "This input";
			if (text.trim() == avoidValue) {
				return inputName + " may not be '" + avoidValue + "'";
			}
			return null;
		}
	},

	FITB: function(text) {
		var validationPattern = /(\s|^)____(\W|$)/g;
		if(!text.match(validationPattern)) {
			return "Your question needs to have a blank that looks like this ____ (4 underscores)."
		}
		if((text.match(validationPattern) || []).length > 1) {
			return "Your question can only have one blank in it."
		}
		return null;
	}
};

ValidatingInput.RESET_EVENT = "validator-input-reset";
ValidatingInput.EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
ValidatingInput.URL_REGEX = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

ValidatingInput.propTypes = StrictPropTypes({
	// Type of input (including 'select' or 'textarea'). Default is 'text'
	//    Type 'proxy' means that this will draw the value off a function passed as a prop
	type: PropTypes.oneOf(["text", "password", "email", "textarea",
		"select", "button-dropdown", "proxy", "number"]),

	// Name of the input, passed to the validators for the error message
	inputName: PropTypes.string,

	// Contains array of validating functions or a single function
	// => Functions should return error message (if invalid) or a falsy value (if valid),
	//    (this is backwards of how many validators work) 
	// => Validators will be run in order, stopping at the first invalid test
	validators: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.arrayOf(PropTypes.func)
	]),

	// Array of options (only used if type == select or button-dropdown)
	selectOptions: PropTypes.array,

	// className to pass on the input
	inputClassName: PropTypes.string,

	// className for our wrapper
	className: PropTypes.string,

	// overrides the default error message returned from validators
	errorMessage: PropTypes.string,

	// text to display under the input even when there's no error
	defaultSubText: PropTypes.string,

	// Provides the value instead of the input itself
	proxySource: PropTypes.func,

	// Other props are passed on to the input with { ...this.props }
	placeholder: PropTypes.string,
	defaultValue: PropTypes.string,
	defaultText: PropTypes.string,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,
});

module.exports = ValidatingInput;


// WEBPACK FOOTER //
// ./modules/components/utility/ValidatingInput.js